import React, { FC, useState } from 'react'

import moment from 'moment/moment'

import { CardItem } from '../CardItem/CardItem'
import { CardWrapper } from '../CardWrapper/CardWrapper'

import { IHorseData } from '../../../../../../models/horse/horse.interface'
import { IHorsesWithPaperwork } from '../../tabs/HorsesTab/HorsesTab'

import { isExpiredMembership } from '../../../../../../helpers/requiredFields'
import { useProfile } from '../../../../../../hooks/useProfile'

interface TrackingNumbersCardProps {
  index: number
  horse: IHorseData
  isEditable?: boolean
  horsesWithPaperwork: IHorsesWithPaperwork[]
  setHorsesWithPaperwork: (state: IHorsesWithPaperwork[]) => void
}
export const TrackingNumbersCard: FC<TrackingNumbersCardProps> = ({
  index,
  horse,
  horsesWithPaperwork,
  setHorsesWithPaperwork,
  isEditable,
}) => {
  const { onSaveEditHorse, onCancelEditHorse, onChangeHorseInput } = useProfile()

  const [isEdit, setIsEdit] = useState(false)

  const getNumber = (number: string | number | null = null) => {
    return number
      ? String(number).length >= 5
        ? `${String(number).slice(0, 5)}..., `
        : `${number}, `
      : ''
  }

  const getExpiration = (expiration: Date | string | null = null) => {
    return expiration && `Exp. ${moment(expiration).format('D MMM YYYY')}`
  }
  return (
    <CardWrapper
      title="Tracking Numbers"
      onSaveEdit={() => onSaveEditHorse({ index, horsesWithPaperwork, setIsEdit })}
      onCancelEdit={() =>
        onCancelEditHorse({ index, horsesWithPaperwork, setHorsesWithPaperwork, setIsEdit })
      }
      isEditable={isEditable}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
    >
      <CardItem
        fieldType="number"
        fieldKey="horseMicrochipNumber"
        label="Microchip"
        defaultValue={`${getNumber(horse.horseMicrochipNumber)}${getExpiration(horse.horseMicrochipExpiration)}`}
        isInvalid={!horse.horseMicrochipNumber || !horse.horseMicrochipExpiration}
        isMissing={!horse.horseMicrochipNumber}
        isExpired={isExpiredMembership(horse.horseMicrochipExpiration)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="number"
        fieldKey="horseDNACaseNumber"
        label="DNA case number"
        defaultValue={`${getNumber(horse.horseDNACaseNumber)}${getExpiration(horse.horseDNACaseExpiration)}`}
        isInvalid={!horse.horseDNACaseNumber || !horse.horseDNACaseExpiration}
        isMissing={!horse.horseDNACaseNumber}
        isExpired={isExpiredMembership(horse.horseDNACaseExpiration)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="number"
        fieldKey="horsePassportNumber"
        label="Passport number"
        defaultValue={`${getNumber(horse.horsePassportNumber)}${getExpiration(horse.horsePassportExpiration)}`}
        isInvalid={!horse.horsePassportNumber || !horse.horsePassportExpiration}
        isMissing={!horse.horsePassportNumber}
        isExpired={isExpiredMembership(horse.horsePassportExpiration)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
    </CardWrapper>
  )
}
